import { Type } from '../utils/type'

export const StoreComment = Type('StoreComment', {
  id: Number,
  store_id: Number,
  key: String,
  text: String,
  created_at: String,
})

export const makeStoreComment = (id, store_id, type, text, created_at) => {
  return StoreComment(id, store_id, type, text, created_at)
}

export const serializeDomain = (domain) => domain.host
